import React from "react";

function RightActive() {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5625 14.25L8.4375 8L1.5625 1.75"
        stroke="var(--gray-50)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default RightActive;
